import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import orderService from './orderService';

const initialState = {
	orders: [],
	ordersCount: [],
	monthlyOrderCounts: [],
	totalPages: 0,
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

export const getAllOrder = createAsyncThunk(
	'orders/getallorder',
	async ({ data, page }, thunkAPI) => {
		try {
			const res = await orderService.getAllOrder(data, page);
			return res;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);
export const getOrderMonthlyCount = createAsyncThunk(
	'orders/getOrderMonthlyCount',
	async (data, thunkAPI) => {
		try {
			const res = await orderService.getOrderMonthlyCount(data);

			return res;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getOrderDetailsById = createAsyncThunk(
	'orders/getOrderDetailsById',
	async (id, thunkAPI) => {
		try {
			const res = await orderService.getOrderDetailsById(id);
			return res;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const updateOrderStatus = createAsyncThunk(
	'orders/updateOrderStatus',
	async (data, thunkAPI) => {
		try {
			const res = await orderService.updateOrderStatus(data);
			return res;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getUsersAllOrder = createAsyncThunk(
	'/order/getusersallorders',
	async ({ data, page }, thunkAPI) => {
		try {
			const response = await orderService.getUsersAllOrder(data, page);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const getAllOrderCounts = createAsyncThunk('/order/getallordercounts', async (thunkAPI) => {
	try {
		const response = await orderService.getAllOrderCounts();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

export const getUsersOrdersCounts = createAsyncThunk(
	'/order/getusersordercounts',
	async (thunkAPI) => {
		try {
			const response = await orderService.getUsersOrdersCounts();
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

export const createOrder = createAsyncThunk(
	'/order/createorder',
	async (orderDetails, thunkAPI) => {
		try {
			const response = await orderService.createOrder(orderDetails);
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

const orderSlice = createSlice({
	name: 'orders',
	initialState,
	reducers: {
		reset: (state) => {
			state.orders = [];
			state.ordersCount = [];
			state.monthlyOrderCounts = [];
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getAllOrder.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllOrder.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.orders = action.payload.orders;
				state.message = action.payload.message;

				state.isError = false;
			})
			.addCase(getAllOrder.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getOrderDetailsById.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getOrderDetailsById.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.message = action.payload.message;
				state.isError = false;
			})
			.addCase(getOrderDetailsById.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(updateOrderStatus.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(updateOrderStatus.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.message = action.payload.message;
				state.isError = false;
			})
			.addCase(updateOrderStatus.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getUsersAllOrder.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getUsersAllOrder.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.orders = action.payload.orders;
				state.isError = false;
			})
			.addCase(getUsersAllOrder.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getAllOrderCounts.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getAllOrderCounts.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.ordersCount = action.payload.ordersCount;
				state.isError = false;
			})
			.addCase(getAllOrderCounts.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getUsersOrdersCounts.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getUsersOrdersCounts.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.ordersCount = action.payload.ordersCount;
				state.isError = false;
			})
			.addCase(getUsersOrdersCounts.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(createOrder.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(createOrder.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.ordersCount = action.payload.ordersCount;
				state.isError = false;
			})
			.addCase(createOrder.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getOrderMonthlyCount.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getOrderMonthlyCount.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.monthlyOrderCounts = action.payload.monthlyOrderCounts;
				state.isError = false;
			})
			.addCase(getOrderMonthlyCount.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			});
	},
});

export const { reset } = orderSlice.actions;
export default orderSlice.reducer;
